import create from "zustand";

export const useScreenshareStore = create((_, __) => ({
	screenshareStudents: new Set<string>(),
}));
